import axios from 'axios';

const BASE_URL = '/painel-api/api/usuarios-externos';

export const elevarNivel = (codigoValidador: string) =>
  axios.post(`${BASE_URL}/elevar-nivel-alvara/${codigoValidador}`);

export const findNiveis = () => axios.get(`${BASE_URL}/niveis`);
